/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompteBancaireDto } from './CompteBancaireDto';
import {
    CompteBancaireDtoFromJSON,
    CompteBancaireDtoFromJSONTyped,
    CompteBancaireDtoToJSON,
    CompteBancaireDtoToJSONTyped,
} from './CompteBancaireDto';

/**
 * Bénéficiaire du tunnel et ses comptes bancaires sélectionnables.
 * @export
 * @interface FunnelBeneficiaireDto
 */
export interface FunnelBeneficiaireDto {
    /**
     * 
     * @type {string}
     * @memberof FunnelBeneficiaireDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FunnelBeneficiaireDto
     */
    personneId?: string;
    /**
     * 
     * @type {string}
     * @memberof FunnelBeneficiaireDto
     */
    compteBancaireId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FunnelBeneficiaireDto
     */
    personneDesignation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FunnelBeneficiaireDto
     */
    iban?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FunnelBeneficiaireDto
     */
    typePersonne?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FunnelBeneficiaireDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FunnelBeneficiaireDto
     */
    telephone?: string | null;
    /**
     * 
     * @type {Array<CompteBancaireDto>}
     * @memberof FunnelBeneficiaireDto
     */
    listeComptesBancaires?: Array<CompteBancaireDto> | null;
}

/**
 * Check if a given object implements the FunnelBeneficiaireDto interface.
 */
export function instanceOfFunnelBeneficiaireDto(value: object): value is FunnelBeneficiaireDto {
    return true;
}

export function FunnelBeneficiaireDtoFromJSON(json: any): FunnelBeneficiaireDto {
    return FunnelBeneficiaireDtoFromJSONTyped(json, false);
}

export function FunnelBeneficiaireDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunnelBeneficiaireDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'personneId': json['personneId'] == null ? undefined : json['personneId'],
        'compteBancaireId': json['compteBancaireId'] == null ? undefined : json['compteBancaireId'],
        'personneDesignation': json['personneDesignation'] == null ? undefined : json['personneDesignation'],
        'iban': json['iban'] == null ? undefined : json['iban'],
        'typePersonne': json['typePersonne'] == null ? undefined : json['typePersonne'],
        'email': json['email'] == null ? undefined : json['email'],
        'telephone': json['telephone'] == null ? undefined : json['telephone'],
        'listeComptesBancaires': json['listeComptesBancaires'] == null ? undefined : ((json['listeComptesBancaires'] as Array<any>).map(CompteBancaireDtoFromJSON)),
    };
}

export function FunnelBeneficiaireDtoToJSON(json: any): FunnelBeneficiaireDto {
    return FunnelBeneficiaireDtoToJSONTyped(json, false);
}

export function FunnelBeneficiaireDtoToJSONTyped(value?: FunnelBeneficiaireDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'personneId': value['personneId'],
        'compteBancaireId': value['compteBancaireId'],
        'personneDesignation': value['personneDesignation'],
        'iban': value['iban'],
        'typePersonne': value['typePersonne'],
        'email': value['email'],
        'telephone': value['telephone'],
        'listeComptesBancaires': value['listeComptesBancaires'] == null ? undefined : ((value['listeComptesBancaires'] as Array<any>).map(CompteBancaireDtoToJSON)),
    };
}

